// extracted by mini-css-extract-plugin
export default {"tabs_bar":"privateHomePage_tabs_bar__JAwvW","tab_bar_icon_active":"privateHomePage_tab_bar_icon_active__1nRli","tab_bar_icon":"privateHomePage_tab_bar_icon__NFmAy"};